import { render, staticRenderFns } from "./ProfileComponent.vue?vue&type=template&id=901bfb48&scoped=true&"
import script from "./ProfileComponent.vue?vue&type=script&lang=js&"
export * from "./ProfileComponent.vue?vue&type=script&lang=js&"
import style0 from "./ProfileComponent.vue?vue&type=style&index=0&id=901bfb48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "901bfb48",
  null
  
)

component.options.__file = "ProfileComponent.vue"
export default component.exports